import { Injectable } from '@angular/core';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { BRANDS } from 'src/app/shared/models/screen-size.enum';
import { StateManagementService } from 'src/app/shared/services/state-management.service';

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  constructor(private stateManagementService: StateManagementService) {}

  isWeiserBrand(): boolean {
    return this.stateManagementService.getUserBrand() === BRANDS.WEISER;
  }

  getBrandDisplayName(): string {
    return this.isWeiserBrand()
      ? CONSTANTS.WEISER_UNITE_TITLE
      : CONSTANTS.KWIKSET_UNITE_TITLE;
  }

  getFaqSupportVideosLink(): string {
    if (this.isWeiserBrand()) {
      return this.isFrench()
        ? CONSTANTS.FAQ_SUPPORT_VIDEOS_LINK_FRENCH_WEISER
        : CONSTANTS.FAQ_SUPPORT_VIDEOS_LINK_WEISER;
    }
    return CONSTANTS.FAQ_SUPPORT_VIDEOS_LINK;
  }

  getSoftwareUserGuideLink(): string {
    return this.isWeiserBrand()
      ? CONSTANTS.SOFTWARE_USER_GUIDE_LINK_WEISER
      : CONSTANTS.SOFTWARE_USER_GUIDE_LINK;
  }

  getQuickReferenceGuideLink(): string {
    return this.isWeiserBrand()
      ? CONSTANTS.QUICK_REFERENCE_GUIDE_LINK_WEISER
      : CONSTANTS.QUICK_REFERENCE_GUIDE_LINK;
  }

  getReleaseNotesLink(): string {
    if (this.isWeiserBrand()) {
      return this.isFrench()
        ? CONSTANTS.RELEASE_NOTES_LINK_FRENCH_WEISER
        : CONSTANTS.RELEASE_NOTES_LINK_WEISER;
    }
    return CONSTANTS.RELEASE_NOTES_LINK;
  }

  getTermsOfServiceLink(): string {
    if (this.isWeiserBrand()) {
      return this.isFrench()
        ? CONSTANTS.TERMS_OF_SERVICE_FRENCH_WEISER
        : CONSTANTS.TERMS_OF_SERVICE_WEISER;
    }
    return CONSTANTS.TERMS_OF_SERVICE;
  }

  getPrivacyPolicyLink(): string {
    if (this.isWeiserBrand()) {
      return this.isFrench()
        ? CONSTANTS.PRIVACY_POLICY_LINK_FRENCH
        : CONSTANTS.PRIVACY_POLICY_LINK_WEISER;
    }
    return CONSTANTS.PRIVACY_POLICY_LINK;
  }

  getMasterCredentialPolicyLink(): string {
    return this.isWeiserBrand()
      ? CONSTANTS.MASTER_CREDENTIAL_POLICY_LINK_WEISER
      : CONSTANTS.MASTER_CREDENTIAL_POLICY_LINK;
  }

  getSupportEmail(): string {
    return this.isWeiserBrand()
      ? CONSTANTS.SUPPORT_EMAIL_WEISER
      : CONSTANTS.SUPPORT_EMAIL_KWIKSET;
  }

  getSupportPhoneTel(): string {
    return this.isWeiserBrand()
      ? CONSTANTS.SUPPORT_PHONE_WEISER
      : CONSTANTS.SUPPORT_PHONE_KWIKSET;
  }

  openSupportPhone(): void {
    window.location.href = this.getSupportPhoneTel();
  }

  private isFrench(): boolean {
    return this.stateManagementService.getUserLanguage() === LANG_CONST.FRENCH;
  }
}
